module.exports = __webpack_public_path__ + "ad961f34.svg";